import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { ICompanyConfigFeature } from './company-config.feature.state';
import { CompanyConfigState } from './company-config.state';

export const getCompanyConfigState: MemoizedSelector<ICompanyConfigFeature, CompanyConfigState> = createFeatureSelector<CompanyConfigState>(
  nameof<ICompanyConfigFeature>('CompanyConfigFeature')
);

export const getIsLoading = createSelector(getCompanyConfigState, (state: CompanyConfigState) => state.isLoading);

export const getFailures = createSelector(getCompanyConfigState, (state: CompanyConfigState) => state.failures);

export const getCompanyConfig = createSelector(getCompanyConfigState, (state: CompanyConfigState) => state.companyConfig);

export const getCompanyConfigIndex = createSelector(getCompanyConfigState, (state: CompanyConfigState) => state.companyConfigIndex);

export const getIsContrastColor = createSelector(getCompanyConfigState, (state: CompanyConfigState) => state.isContrastColor);

export const getIsAnonymousBrowsing = createSelector(getCompanyConfigState, (state: CompanyConfigState) => state.isAnonymousBrowsing);

export const getOrderFromSite = createSelector(getCompanyConfigState, (state: CompanyConfigState) => state.orderFromSite);

export const getSiteId = createSelector(getCompanyConfigState, (state: CompanyConfigState) => state.siteId);
